<template>
  <div :data-test="`recruiter-compliance-invited-on-${index}`">
    <WdsText v-if="formatted" :text="formatted" sm />
    <WdsText v-else secondary sm :text="$t('—')" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const RecruiterComplianceInvitedOnColumn = graphql(`
  fragment RecruiterComplianceInvitedOnColumn on CompanyRecruiter {
    id
    invitedAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof RecruiterComplianceInvitedOnColumn>
  index: number
}>()

const contact = computed(() => useFragment(RecruiterComplianceInvitedOnColumn, props.row))

const formatted = computed(() => {
  if (!contact.value.invitedAt) return null
  const parsed = Date.parse(contact.value.invitedAt)
  if (Number.isNaN(parsed)) return contact.value.invitedAt
  return new Date(parsed).toISOString().slice(0, 10)
})
</script>
